'use client'

import { FavoriteButtonPrimary } from 'favorite/src/FavoriteButtonPrimary'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { ProductLocations } from 'product/types/ProductLocations'
import { applyStylesIf, cx } from 'utils/cx'

import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useProduct } from '../../contexts/ProductProvider/ProductProvider'

import type { JSX } from 'react'
import styles from './FavoriteButton.module.scss'

export function FavoriteButton(): JSX.Element {
	const { selectedColor } = useColors()
	const { product } = useProduct()
	const {
		country: { hasOnlineSale },
	} = useMasterData()

	return (
		<FavoriteButtonPrimary
			productId={product.id}
			selectedColorId={selectedColor.id}
			dataTestIds={{
				active: dataTestIds['pdp.productInfo.favorite.active'],
				inactive: dataTestIds['pdp.productInfo.favorite.inactive'],
			}}
			location={ProductLocations.Main}
			className={cx(applyStylesIf(hasOnlineSale, styles.hideOnMobile))}
			showLabel={!hasOnlineSale || !selectedColor.isSellable}
			notification
		/>
	)
}
